import { Component, EventEmitter, Input, Output } from '@angular/core';
import { Entity } from '../../shared/entity-search/entity-search.service';

@Component({
  selector: 'dcc-entity-path-display',
  templateUrl: './entity-path-display.component.html',
  styleUrls: ['./entity-path-display.component.scss'],
})
export class EntityPathDisplayComponent {
  @Input()
  companiesEntities: Entity[] = [];
  @Input()
  groupsEntities: Entity[] = [];
  @Input()
  vehiclesEntities: Entity[] = [];
  @Input()
  devicesEntities: Entity[] = [];
  @Input()
  stackEntities: Entity[] = [];
  @Input()
  predefinedEntity = false;
  @Input()
  allowDelete = false;

  @Output()
  deleted: EventEmitter<Entity> = new EventEmitter<Entity>();

  get haveEntities(): boolean {
    return (
      [
        ...this.companiesEntities,
        ...this.groupsEntities,
        ...this.vehiclesEntities,
        ...this.devicesEntities,
        ...this.stackEntities,
      ].length > 0
    );
  }

  removeEntity(deleted: Entity) {
    this.deleted.next(deleted);
  }
}
